import InitialState from './initialState';
import ActionTypes from '../actions/actionTypes';

export default function(state = InitialState.user, action) {
  switch (action.type) {
    case ActionTypes.USER_SET: {
      return action.payload;
    }
    default: {
      return state;
    }
  }
}
